import { isSetupSupportNudgeAutoDismissed } from '@court-sync/shared';

export interface SetupSupportNudgeVisibilityInput {
  hasAcademySection: boolean;
  hasActiveSubscription: boolean;
  subscriptionLoading: boolean;
  hasCurrentAcademy: boolean;
  setupTaskCount: number;
  allSetupComplete: boolean;
  checklistDismissed: boolean;
  checklistCompletedAt: string | null;
  nudgeDismissed: boolean;
  showSetupChecklist: boolean;
  now?: Date;
}

/** Show the dismissible support CTA after the getting-started checklist is finished or hidden. */
export function shouldShowSetupSupportNudge(input: SetupSupportNudgeVisibilityInput): boolean {
  const setupChecklistFinished =
    input.setupTaskCount > 0 && (input.allSetupComplete || input.checklistDismissed);

  if (
    input.allSetupComplete &&
    input.checklistCompletedAt &&
    isSetupSupportNudgeAutoDismissed(input.checklistCompletedAt, input.now)
  ) {
    return false;
  }

  return (
    input.hasAcademySection &&
    input.hasActiveSubscription &&
    !input.subscriptionLoading &&
    input.hasCurrentAcademy &&
    setupChecklistFinished &&
    !input.nudgeDismissed &&
    !input.showSetupChecklist
  );
}

export interface ClubSetupSupportNudgeVisibilityInput {
  hasClubSection: boolean;
  hasActiveSubscription: boolean;
  subscriptionLoading: boolean;
  hasCurrentClub: boolean;
  clubSetupTaskCount: number;
  allClubSetupComplete: boolean;
  clubChecklistDismissed: boolean;
  clubChecklistCompletedAt: string | null;
  clubNudgeDismissed: boolean;
  showClubSetupChecklist: boolean;
  now?: Date;
}

/** Show the dismissible support CTA after the club getting-started checklist is finished or hidden. */
export function shouldShowClubSetupSupportNudge(
  input: ClubSetupSupportNudgeVisibilityInput,
): boolean {
  const clubChecklistFinished =
    input.clubSetupTaskCount > 0 &&
    (input.allClubSetupComplete || input.clubChecklistDismissed);

  if (
    input.allClubSetupComplete &&
    input.clubChecklistCompletedAt &&
    isSetupSupportNudgeAutoDismissed(input.clubChecklistCompletedAt, input.now)
  ) {
    return false;
  }

  return (
    input.hasClubSection &&
    input.hasActiveSubscription &&
    !input.subscriptionLoading &&
    input.hasCurrentClub &&
    clubChecklistFinished &&
    !input.clubNudgeDismissed &&
    !input.showClubSetupChecklist
  );
}
